import React, { useEffect, useState } from 'react';
import { makeStyles, Box, Typography, Grid, InputAdornment, ListItem, IconButton, TextField, Tabs, Tab, AppBar, Paper } from '@material-ui/core';
import { isImage, findColor, NODE_NAMES } from '../utils';
import IconRadiusButton from '../CustomizedUIs/IconRadiusButton'
import DeleteIcon from '../assets/icons/primary-blue-bin.png'
import { useTranslate, usePermissions, useDataProvider } from 'react-admin';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import CustomPoper from '../CustomizedUIs/CustomPoperCalendar';
import CustomTextField from '../users/CustomTextField';
import CustomTextFieldPinCode from '../CustomizedUIs/CustomTextFieldPinCode'
import icAttachment from '../assets/icons/ic_attachment.png';
import plus from '../assets/icons/white-plus.png';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import DialogChooseFile from '../file-management/file-management-dialog';
import { baseApiUrl } from '../dataProvider/sails';
import fakeData from './fakedata.json';
import { useSelector, useDispatch } from 'react-redux';
import { PrimaryButton, IconButton as CustomizeIconButton, SourceIcon } from '../common/button';
import { changeNodeGlobalData, changeTreeData } from '../redux/actions/tree-action';
import DialogPreview from './dialog-editor';
import SwitchBox from '../common/switch-box';
import ThumbnailIcon from './thumbnail';

const useStyles = makeStyles(() => ({
    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    borderCard: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '600px',
        // height: '132px',
        marginTop: '18px'
    },
    titleNodeType: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },
    btnMetaData: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
    },
    textMetaData: {
        fontFamily: 'UniviaPro',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#237fc2',
        padding: 8
    },
    textChoose: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '11px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#88898c',
        textAlign: 'center',
        paddingTop: 60,
    },
    SunEditorPreview: {
        // width: 'fit-content !important',
        margin: '10px auto !important',
        height: 'auto !important',
        // transform: 'scaleX(0.75)',
        // marginLeft: '-25% !important',
        // marginTop: '-10vh !important'
    },
    textLabel: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: '0.13px',
        color: ' #88898c',
    },
    textLableError: {
        marginBottom: 8,
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.13px',
        color: '#eb5a4d !important',
    },
    textError: {
        fontFamily: 'UniviaPro',
        fontSize: '11px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '24px',
        letterSpacing: 'normal',
    },
    underlineCodeInput: {
        "&&&:before": {
            borderBottom: "none"
        },
        "&&:after": {
            borderBottom: "none"
        }
    },
    textNamePreview: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '15.5px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '11.3px',
        letterSpacing: '0.16px'
    },
    disabledContent: {
        pointerEvents: 'none',
        opacity: 0.4
    },
    container: {
        height: 50,
        width: 7,
        borderTopRightRadius: 2,
        borderTopLeftRadius: 2,
        borderBottomLeftRadius: 2,
        borderBottomRightRadius: 2,
        transition: '0.2s',
    },
    textNameTempaletPreview: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '15.5px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        letterSpacing: '0.16px'
    },
}));

// const TEMPLATE = {
//     STAFF: "STAFF",
//     PATIENT: 'PATIENT'
// }


const MetaData = ({ value, textOnChange, validate, onRemove }) => {
    const classes = useStyles();
    const { isEditing } = useSelector(state => state.tree);

    return (
        <Box display='flex' width={600} mt={1}>
            <Box display='flex' borderRadius={4} bgcolor='background.paper' ml={2} alignItems='center' px={1}>
                <TextField
                    disabled={!isEditing}
                    required
                    label="value"
                    error={validate && validate.value.isError && validate.value.message != ""}
                    helperText={(validate && validate.value.isError) ? validate.value.message : ""}
                    value={value}
                    onBlur={textOnChange('value')}
                    onChange={textOnChange('value')}
                    size="small"
                    style={{ width: '157px' }}
                    FormHelperTextProps={{
                        className: classes.textError
                    }}
                    InputLabelProps={{
                        // className: classes.textLabel,
                        classes: {
                            root: classes.textLabel,
                            error: classes.textLableError
                        }
                    }}
                    InputProps={{
                        classes: {
                            underline: classes.underlineCodeInput,
                        }
                    }}
                />
            </Box>
            <IconRadiusButton style={{ marginLeft: 8 }} onClick={onRemove} disabled={!isEditing}>
                <img src={DeleteIcon} width='18px' height='18px'></img>
            </IconRadiusButton>
        </Box>
    )
}

function Preview(props) {
    const classes = useStyles();
    const translate = useTranslate();
    const { permissions, loaded } = usePermissions();
    const dataProvider = useDataProvider();
    const dispatch = useDispatch();

    const [openPreview, setOpenPreview] = useState(false);
    const [openPoper, setOpenPopper] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [openColorPicker, setOpenColorPicker] = useState(false);
    const [validateMetaDatas, setValidateMetaDatas] = useState([]);
    const [defaultPinCode, setDefaultPinCode] = useState();
    const [showPassword, setShowPassword] = useState(false);
    let { isEditing, tree, nodeSelected, selectedInfoPage } = useSelector(state => state.tree);
    nodeSelected = props.currentNodeLinkMenu ? props.currentNodeLinkMenu : nodeSelected;
    const { preview } = nodeSelected.applicationData;
    const { name, icon, color, parental, metadata } = preview;
    const { hasArchiveVideos, hasArchiveImages } = parental

    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    });
    const [validate, setValidate] = useState({
        name: {
            isError: true,
            message: ''
        },
        pinCode: {
            isError: false,
            message: ''
        }
    });

    const onChangeNodePreview = (preview) => {
        const newNode = {
            ...nodeSelected.applicationData,
            preview: preview
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const textOnChange = prop => (e) => {
        onChangeNodePreview({
            ...preview,
            [prop]: e.target.value
        });
        // validateFc(prop, e.target.value)
    }

    const handleClickSelectBoxColor = () => {
        setOpenColorPicker(!openColorPicker)
    }

    const onChangeColor = (color) => {
        onChangeNodePreview({
            ...preview,
            color: color.Value
        });
        const recursive = (array = []) => {
            if (array.children && array.children.length > 0)
                for (let j = 0; j < array.children.length; j++) {
                    array.children[j].applicationData.preview.color = color.Value
                    recursive(array.children[j])
                }
        }
        for (let i = 0; i < tree.length; i++) {
            for (let j = 0; j < tree[i].children[0].children.length; j++) {
                if (nodeSelected.id === tree[i].children[0].children[j].id) {
                    recursive(tree[i].children[0].children[j])
                }
            }
        }
        setOpenColorPicker(false);
        dispatch(changeTreeData(tree))
    }

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    //----Meta data

    const onChangMetaData = index => prop => (e) => {
        var tempArray = metadata.slice()
        tempArray[index][prop] = e.target.value
        onChangeNodePreview({
            ...preview,
            metadata: tempArray
        });
        validateMetaData(index)(e.target.value)(prop)

    }

    const validateMetaData = index => value => prop => {
        var validates = validateMetaDatas.slice()
        if (value == "") {
            validates[index][prop].isError = true
            validates[index][prop].message = "required"
        }
        else {
            validates[index][prop].isError = false
            validates[index][prop].message = ""
        }
        setValidateMetaDatas(validates)
    }

    const onClickMetaData = () => {
        var tempArray = metadata.slice()
        var validates = validateMetaDatas.slice()
        tempArray.push({
            value: "",
        })
        validates.push({
            value: { isError: true, message: "" }
        })
        setValidateMetaDatas(validates)
        onChangeNodePreview({
            ...preview,
            metadata: tempArray
        });
    }

    const onRemoveMetaData = index => () => {
        var tempArray = metadata.slice()
        tempArray.splice(index, 1)
        var validates = validateMetaDatas.slice()
        validates.splice(index, 1)
        setValidateMetaDatas(validates)
        onChangeNodePreview({
            ...preview,
            metadata: tempArray
        });
    }
    const findLanguage = () => {
        for (let i = 0; i < tree.length; i++) {
            if (tree[i].children[0].children.findIndex(t => t.id === nodeSelected.id) !== -1) {
                return i
            }
            return 0
        }
    }
    //------switch
    const onChangeParental = prop => (value) => {
        let index = null;
        if (prop === 'hasArchiveImages' && value) {
            onChangeNodePreview({
                ...preview,
                parental: {
                    ...preview.parental,
                    [prop]: value,
                    ['hasArchiveVideos']: !value,
                }
            });
        } else if (prop === 'hasArchiveVideos' && value) {
            onChangeNodePreview({
                ...preview,
                parental: {
                    ...preview.parental,
                    [prop]: value,
                    ['hasArchiveImages']: !value,
                }
            });
        } else if (prop === 'audioIN' && value) {
            onChangeNodePreview({
                ...preview,
                parental: {
                    ...preview.parental,
                    [prop]: value,
                    ['audioIN']: value,
                    ['audioOUT']: preview.parental.audioIN && false,
                }
            });
        } else if (prop === 'audioOUT' && value) {
            onChangeNodePreview({
                ...preview,
                parental: {
                    ...preview.parental,
                    [prop]: value,
                    ['audioOUT']: value,
                    ['audioIN']: preview.parental.audioOUT && false,
                }
            });
        } else {
            onChangeNodePreview({
                ...preview,
                parental: {
                    ...preview.parental,
                    [prop]: value,
                }
            });
            index = findLanguage()

            if (index !== null) {
                for (let j = 0; j < tree[index].children[0].children.length; j++) {
                    if (nodeSelected.id === tree[index].children[0].children[j].id) {
                        continue
                    } else {
                        tree[index].children[0].children[j].applicationData.preview.parental = { ...tree[index].children[0].children[j].applicationData.preview.parental, hasLogout: false }
                    }
                }
            }
        }
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword)
    };

    const setIcon = (icon) => {
        onChangeNodePreview({
            ...preview,
            icon
        });
    }

    const handleOpenFileDialog = () => {
        setOpenFile({
            status: true,
            defaultId: 5,
            format: isImage,
            setResponse: setIcon
        })
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }

    const handleChoose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }

    const handleClosePreview = () => {
        setOpenPreview(!openPreview)
    }

    const onChangePinCode = props => (value) => {
        const valueParsed = parseInt(value);
        switch (props) {
            case 'logout':
                if (value === '') {
                    onChangeParental('logoutCode')('');
                } else if (!isNaN(valueParsed)) {
                    onChangeParental('logoutCode')(value.toString());
                }
                break;
            case 'pinCode':
                if (value === '') {
                    onChangeParental('code')('');
                } else if (!isNaN(valueParsed)) {
                    onChangeParental('code')(value.toString());
                }
                break;
            default:
                break;
        }
    }



    const getFile = () => {
        if (icon) {
            dataProvider('GET_ONE', 'categories', {
                id: icon.id
            }).then(({ data }) => {
                if (data) {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        preview: {
                            ...preview,
                            icon: data
                        }
                    };
                    dispatch(changeNodeGlobalData(newNode, nodeSelected.id));
                }
                else {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        preview: {
                            name: nodeSelected.applicationData.preview.name,
                            color: nodeSelected.applicationData.preview.color,
                            metadata: nodeSelected.applicationData.preview.metadata,
                            parental: nodeSelected.applicationData.preview.parental,
                        }
                    };
                    dispatch(changeNodeGlobalData(newNode, nodeSelected.id));
                }
            }).catch(error => {
                console.log('GET FILE ERROR:', error);
            });
        }
    }
    const getSettings = () => {
        dataProvider('GET_LIST', "settings", {
            filter: {
                cluster: null,
                room: null,
                name: 'Default Pin Code'
            },
            sort: {},
            pagination: {}
        }).then(({ data }) => {
            setDefaultPinCode(data[0])
        }, []);
    }

    useEffect(() => {
        getSettings()
        getFile();
    }, [])

    const colorObject = findColor(fakeData, color);
    if (!loaded) return null
    return (
        <Box>
            <DialogPreview open={openPreview} onClose={() => handleClosePreview()} nodeData={nodeSelected}></DialogPreview>
            <hr style={{ marginTop: "30px", borderTopColor: '#f3f7fa' }} />
            <Box width='600px' mt={3.5} pb={2} className={props.isLinkedMenu ? classes.disabledContent : ''}>
                <Grid container>
                    <Grid item xs={6} height="131px" >
                        <Typography className={classes.Title} >{translate('resources.infoPage.heading')}</Typography>
                        <Box width="300px" mt={2} >
                            <Box height="78px">
                                <CustomTextField
                                    disabled={!isEditing}
                                    // onBlur={() => {
                                    //     validateFc('password', name)
                                    // }}
                                    id="filled-basic"
                                    label={'Name'}
                                    value={name}
                                    error={validate.name.message != "" && validate.name.isError}
                                    helperText={validate.name.message}
                                    onChange={textOnChange('name')}
                                    style={{ width: 300 }}
                                    endDom={
                                        <InputAdornment position="end">
                                            <CustomPoper
                                                color={'#e5f1f8'}
                                                fontSize={'11px'}
                                                open={openPoper}
                                                anchorEl={anchorEl}
                                                handleClick={handleClickOpenPoper}
                                                handleClose={handleClosePoper}
                                                title={translate(`pos.common.name`)}
                                                content={translate(`pos.common.contentName`)}
                                                icon={<b>?</b>}
                                            />
                                        </InputAdornment>
                                    }
                                />
                            </Box>
                            {
                                nodeSelected.applicationData.nodeType.includes(NODE_NAMES.MESSAGE) && <>
                                    <SwitchBox
                                        disabled={!isEditing}
                                        label={
                                            parental.hasArchiveImages
                                                ? translate(`resources.infoPage.enableArchiveImages`).toUpperCase()
                                                : translate(`resources.infoPage.disableArchiveImages`).toUpperCase()
                                        }
                                        checked={parental.hasArchiveImages ? true : false}
                                        onChange={(e) => onChangeParental('hasArchiveImages')(e.target.checked)}
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            marginTop: 18,
                                            width: 170,
                                            borderRadius: 0,
                                        }}
                                    />
                                    <SwitchBox
                                        disabled={!isEditing}
                                        label={
                                            parental.hasArchiveVideos
                                                ? translate(`resources.infoPage.enableArchiveVideos`).toUpperCase()
                                                : translate(`resources.infoPage.disableArchiveVideos`).toUpperCase()
                                        }
                                        checked={parental.hasArchiveVideos ? true : false}
                                        onChange={(e) => onChangeParental('hasArchiveVideos')(e.target.checked)}
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            marginTop: 18,
                                            width: 170,
                                            borderRadius: 0,
                                        }}
                                    />
                                </>
                            }
                            {
                                nodeSelected.applicationData.nodeType.includes(NODE_NAMES.AUDIO) && <>
                                    <SwitchBox
                                        disabled={!isEditing}
                                        label={
                                            parental.audioIN
                                                ? translate(`resources.infoPage.enableAudioIN`).toUpperCase()
                                                : translate(`resources.infoPage.disableAudioIN`).toUpperCase()
                                        }
                                        checked={parental.audioIN ? true : false}
                                        onChange={(e) => onChangeParental('audioIN')(e.target.checked)}
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            marginTop: 18,
                                            width: 170,
                                            borderRadius: 0,
                                        }}
                                    />
                                    <SwitchBox
                                        disabled={!isEditing}
                                        label={
                                            parental.audioOUT
                                                ? translate(`resources.infoPage.enableAudioOUT`).toUpperCase()
                                                : translate(`resources.infoPage.disableAudioOUT`).toUpperCase()
                                        }
                                        checked={parental.audioOUT ? true : false}
                                        onChange={(e) => onChangeParental('audioOUT')(e.target.checked)}
                                        style={{
                                            paddingTop: 3,
                                            paddingBottom: 3,
                                            marginTop: 18,
                                            width: 170,
                                            borderRadius: 0,
                                        }}
                                    />
                                </>
                            }
                            {nodeSelected.nodelevel < 2 &&
                                <Box>
                                    <SelectBox
                                        disabled={!isEditing}
                                        label={'Color'}
                                        value={colorObject.Name}
                                        open={openColorPicker}
                                        handleClick={() => handleClickSelectBoxColor()}
                                    >
                                        {
                                            fakeData.map((color, index) => (
                                                <Box className={classes.boxBoder} key={index.toString()}>
                                                    <ListItem style={{ padding: '8px' }} button onClick={() => onChangeColor(color)}>
                                                        <Typography className={classes.TexTSelect} >{color.Name}</Typography>
                                                        <Box marginLeft='auto' marginRight={1} borderRadius={100} width={20} height={20} bgcolor={color.Value}></Box>
                                                    </ListItem>
                                                </Box>
                                            ))
                                        }
                                    </SelectBox>
                                    {
                                        nodeSelected
                                        && nodeSelected.applicationData
                                        && nodeSelected.applicationData.nodeType
                                        && nodeSelected.applicationData.nodeType === NODE_NAMES.INFO
                                        && <SwitchBox
                                            disabled={!isEditing}
                                            label={
                                                parental.hasLogout
                                                    ? translate(`resources.infoPage.enableLogout`).toUpperCase()
                                                    : translate(`resources.infoPage.disableLogout`).toUpperCase()
                                            }
                                            checked={parental.hasLogout ? true : false}
                                            onChange={(e) => onChangeParental('hasLogout')(e.target.checked)}
                                            style={{
                                                paddingTop: 3,
                                                paddingBottom: 3,
                                                marginTop: 18,
                                                width: 170,
                                                borderRadius: 0,
                                            }}
                                        />
                                    }
                                    {
                                        parental.hasLogout && (
                                            <Box position='relative' bgcolor='background.paper' width={185} height={50}>
                                                <CustomTextFieldPinCode
                                                    disabled={!isEditing}
                                                    id="logoutCode"
                                                    label={translate('resources.infoPage.pin_code_placeholder')}
                                                    value={parental.logoutCode !== '' ? parental.logoutCode : defaultPinCode ? defaultPinCode.value : ''}
                                                    type={'number'}
                                                    helperText={validate.pinCode.message}
                                                    onChange={(e) => onChangePinCode('logout')(
                                                        e.target.value.length === 0
                                                            ? e.target.value
                                                            : e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, e.target.maxLength)
                                                    )}
                                                    showPassword={showPassword}
                                                />

                                                <div data-value={parental.code}></div>
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={handleClickShowPassword}
                                                    edge="end"
                                                    size='small'
                                                    style={{ position: 'absolute', right: 10, top: 20 }}
                                                >
                                                    {showPassword ? <Visibility fontSize='default' /> : <VisibilityOff fontSize='default' />}
                                                </IconButton>
                                            </Box>
                                        )
                                    }
                                </Box>
                            }
                        </Box>
                    </Grid>
                    <Grid item xs={6} style={{ paddingLeft: '20px', height: 'fit-content' }} >
                        <Typography className={classes.Title}>{translate('resources.infoPage.Preview')}</Typography>
                        {colorObject.Value !== '' ?
                            <Box mt={2} style={{ position: 'relative' }}>
                                {
                                    (nodeSelected.nodelevel >= 3 && nodeSelected.applicationData.nodeType === "Info") ? <Box></Box> : icon && <img src={baseApiUrl + "/media/" + icon.fd} width={60} height={60} style={{ position: 'absolute', left: 110, bottom: 45 }} />
                                }
                                <Box width='100%' height='131px' bgcolor={colorObject.Value}></Box>
                                <Typography className={classes.textNamePreview} style={{
                                    position: 'absolute', right: 0, left: 0, bottom: 15, textAlign: 'center',
                                    color: colorObject.Value === '#ffffff' ? '#323131' : '#ffffff'
                                }}>
                                    {name}
                                </Typography>
                            </Box> :
                            <Box mt={2} style={{ background: '#ffffff', height: '131px', width: '100%', position: 'relative' }}>
                                {
                                    !icon ?
                                        <Typography className={classes.textChoose}>{translate('resources.infoPage.choose')}</Typography> :
                                        <img src={baseApiUrl + "/media/" + icon.fd} width={60} height={60} style={{ position: 'absolute', left: 110, bottom: 45 }} />
                                }
                            </Box>}
                    </Grid>
                </Grid>
                <Box className={classes.borderCard} justifyContent='center' alignItems="center" >
                    <Box display='flex' width="100%" alignItems="center">
                        <Box mx={2} display='flex' alignItems="center">
                            <IconButton
                                variant="outlined"
                                color='primary'
                                style={{ marginRight: '10px', padding: 'unset' }}
                            >
                                <img src={icAttachment} width={27} />
                            </IconButton>
                            <Typography className={classes.Title}>{translate('pos.common.icon')}</Typography>
                        </Box>
                        <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                            <PrimaryButton
                                disabled={!isEditing}
                                onClick={() => handleOpenFileDialog()}
                                label={!icon ? translate('pos.common.browse') : translate('pos.common.change')}
                            />
                            <DialogChooseFile
                                formats={openFile.format}
                                defaultId={openFile.defaultId}
                                open={openFile.status}
                                pickerMode='pickMediaOnly'
                                handleClose={handleClose}
                                setChooseValue={openFile.setResponse}
                                handleChoose={handleChoose}
                                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
                            />
                        </Box>
                    </Box>
                    <ThumbnailIcon
                        thumbnail={icon}
                        onClear={() => setIcon(null)}
                        isImage
                    />
                </Box>
                <Box display="flex" my={1} mt={2} justifyContent="space-between" alignItems="flex-start">
                    <PrimaryButton
                        secondary
                        disabled={!isEditing}
                        label={translate(`resources.room.metedata`)}
                        onClick={onClickMetaData}
                    />
                    <Box>
                        <SwitchBox
                            disabled={!isEditing}
                            label={translate(`pos.common.pinLock`).toUpperCase()}
                            checked={parental.show}
                            onChange={(e) => onChangeParental('show')(e.target.checked)}
                            style={{
                                paddingTop: 3,
                                paddingBottom: 3,
                                marginTop: 0,
                                marginBottom: 0,
                                width: 170,
                                borderRadius: 0,
                            }}
                        />
                        {
                            parental.show && (
                                <Box position='relative' bgcolor='background.paper' width={185} height={50}>
                                    <CustomTextFieldPinCode
                                        disabled={!isEditing}
                                        id="pinCodeValue"
                                        label={translate('resources.infoPage.pin_code_placeholder')}
                                        value={parental.code !== '' ? parental.code : defaultPinCode ? defaultPinCode.value : ''}
                                        type={'number'}
                                        helperText={validate.pinCode.message}
                                        onChange={(e) => onChangePinCode('pinCode')(
                                            e.target.value.length === 0
                                                ? e.target.value
                                                : e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, e.target.maxLength)
                                        )}
                                        showPassword={showPassword}
                                    />

                                    <div data-value={parental.code}></div>
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                        size='small'
                                        style={{ position: 'absolute', right: 10, top: 20 }}
                                    >
                                        {showPassword ? <Visibility fontSize='default' /> : <VisibilityOff fontSize='default' />}
                                    </IconButton>
                                </Box>
                            )
                        }
                    </Box>
                </Box>
                <Box my={1} width='173px' mt={2}>
                    {
                        metadata.map((row, index) => (
                            <MetaData
                                key={index}
                                value={row.value}
                                validate={validateMetaDatas[index]}
                                textOnChange={onChangMetaData(index)}
                                onRemove={onRemoveMetaData(index)} />
                        ))
                    }
                </Box>
                <hr style={{ marginTop: "30px", marginBottom: "30px", borderTopColor: '#f3f7fa' }} />
                {
                    nodeSelected && nodeSelected.applicationData && nodeSelected.applicationData.nodeInfo && nodeSelected.applicationData.nodeInfo.htmlContent &&
                    <Paper square>
                        <AppBar position="static">
                            <Tabs value={0} TabIndicatorProps={{
                                style: {
                                    height: "calc(100% - 6px)",
                                    backgroundColor: 'transparent',
                                    border: '3px solid black'
                                }
                            }}
                                style={{
                                    backgroundColor: preview.color
                                }}>
                                {
                                    <Tab
                                        label={!preview.name ? '#NAME' : preview.name}
                                        disableFocusRipple={true}
                                        style={{ color: preview.color !== '#ffffff' ? 'white' : 'black' }}
                                    />
                                }
                            </Tabs>
                        </AppBar>

                        <div role="tabpanel" className={`sun-editor-editable ${classes.SunEditorPreview}`}
                            dangerouslySetInnerHTML={{ __html: nodeSelected.applicationData.nodeInfo.htmlContent.replace(/(<? *script)/gi, 'illegalscript') }} />
                    </Paper>
                }
                <CustomizeIconButton
                    disabled={!isEditing || props.isContact}
                    label={translate(nodeSelected && nodeSelected.applicationData && nodeSelected.applicationData.nodeInfo && nodeSelected.applicationData.nodeInfo.htmlContent ? 'resources.infoPage.editContent' : 'resources.infoPage.addContent')}
                    endIcon={<SourceIcon source={plus} />}
                    onClick={() => setOpenPreview(true)}
                />
            </Box>
        </Box >
    )
}

Preview.propTypes = {
};

export default Preview;
